import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import _ from 'underscore';

/**
 * Spare devs from the JSX API to instantiate components
 */
class InlineComponent {
  constructor(element) {
    this.element = element;
    this.data = this.element.data() || {};
    this.define();
    this.processDefaults();
    this.render();
  }

  processDefaults() {
    if (_.isEmpty(this.defaults)) {
      return;
    }
    this.data = _.defaults(this.data, this.defaults);
  }

  unmount() {
    unmountComponentAtNode(this.element[0]);
  }

  render() {
    if (typeof this.component === 'undefined') {
      throw new Error('You must specify a component');
    }
    render(<this.component {...this.data} />, this.element[0]);
  }
}

module.exports = InlineComponent;
